import { loadAllCars } from '@/modules/car/actions/async/loadAllCars';
import { prepareCarForm } from '@/modules/car/actions/async/prepare-car-form';
import { reloadFormForCurrentCar } from '@/modules/car/actions/async/reload-form-for-current-car';
import { loadDriver } from '@/modules/driver/actions/async/load-driver';
import { reloadPartner } from '@/modules/partner/actions/async/reloadPartner';
import { scrollUp } from '@/shared/actions/scrollUp';
import { createFsmSlice } from '@/shared/store/finite-state-machine/create-fsm-slice';

import { completeOnboarding } from '../actions/completeOnboarding';
import { trackCarSkippedEvent } from '../actions/trackCarSkippedEvent';
import { fsmCfg } from '../fsm-config';
import { FsmState, IDraft, TFsmEffects, TFsmEvent, TFsmState } from '../fsm-types';

const fsmNamespace = 'onboarding-wizard';

const { fsmSlice, fsmSelectors, fsmAsyncActions } = createFsmSlice<
  TFsmState,
  TFsmEvent,
  TFsmEffects,
  IDraft
>({
  config: fsmCfg,
  currentValue: FsmState.welcome,
  effects: {
    PREPARE_DRIVER_FORM: loadDriver,
    PREPARE_CAR_FORM: reloadFormForCurrentCar,
    RESET_CAR_FORM: prepareCarForm,
    COMPLETE_ONBOARDING: completeOnboarding,
    TRACK_CAR_SKIPPED_EVENT: trackCarSkippedEvent,
    SCROLL_UP: scrollUp,
    LOAD_CAR: loadAllCars,
    RELOAD_PARTNER: reloadPartner,
  },
  namespace: fsmNamespace,
});

export { fsmSlice, fsmSelectors, fsmAsyncActions, fsmNamespace };
